import { Space, Spin } from 'antd';
import { ReactNode } from 'react';
import './buttonCustom.css';

interface CustomButtonProps {
  text: string;
  icon?: ReactNode;
  width?: string | number;
  height?: number;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  type?: 'button' | 'submit' | 'reset';
  isLoading?: boolean;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  icon,
  width,
  height,
  onClick,
  className = '',
  disabled = false,
  size = 'medium',
  type = 'button',
  isLoading = false,
}) => {
  return (
    <button
      className={`custom-button ${className}`}
      style={{
        width:
          width ||
          (size === 'xsmall' ? 100 : size === 'small' ? 136 : size === 'large' ? 200 : size === 'xlarge' ? 240 : 180),
        height:
          height ||
          (size === 'xsmall' ? 24 : size === 'small' ? 32 : size === 'large' ? 48 : size === 'xlarge' ? 56 : 40),
        minWidth: 'max-content',
      }}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={type}
    >
      {isLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <Spin size='default' className='custom-spin' />
        </div>
      ) : (
        <Space align='center' size={8}>
          {icon && <span className='button-icon'>{icon}</span>}
          <span
            className={`button-text ${disabled ? 'disabled-text' : ''}`}
            style={{
              fontSize:
                size === 'xsmall' ? 10 : size === 'small' ? 12 : size === 'large' ? 16 : size === 'xlarge' ? 18 : 14,
            }}
          >
            {text}
          </span>
        </Space>
      )}
    </button>
  );
};
